import React, { useState } from "react";

import SelectCountry from "react-select";
import Select from "react-select";

const EditReaderModal = ({
  isOpen,
  handleClose,
  selectedLanguage,
  currentEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  selectedCode,
  handleCodeChange,
  countryCodeDrpOptions,
  mobileNumber,
  handleMobileChange,
  handleAddFnLn,
  handleCloseFnLnModal,
  reference,
  setReference,
  authType,
  handleAuthTypeChange,
  readerPrint,
  setReaderPrint,
  maxPrintsPerIndReader,
  setMaxPrintsPerIndReader,
  printEnabledType,
  docLevelCanPrint
}) => {
  const rpdLevelOptions = authType.rpdLevelOptions || [];

  const rpdLevelValues = rpdLevelOptions.map((option) => option.value);

  const hasEmailOption = rpdLevelValues.includes("email");
  const hasTextOption = rpdLevelValues.includes("text");
  const [previousMaxPrints, setPreviousMaxPrints] = useState("");
  let VerificationOptions = [];
  if (hasEmailOption && hasTextOption) {
    VerificationOptions = [
      { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
      { value: "text", label: selectedLanguage.LstLanguageCodes.UI_Text },
      { value: "both", label: selectedLanguage.LstLanguageCodes.UI_Both },
    ];
  } else {
    if (hasEmailOption) {
      VerificationOptions.push({
        value: "email",
        label: selectedLanguage.LstLanguageCodes.UI_Email,
      });
    }
    if (hasTextOption) {
      VerificationOptions.push({
        value: "text",
        label: selectedLanguage.LstLanguageCodes.UI_Text,
      });
    }
  }

  const selectedVerificationOption = VerificationOptions.find(
    (option) => option?.value?.toLowerCase() === authType?.verificationCode?.toLowerCase()
  );

  if (!isOpen) return null;
  const globePlaceholder = {
    label: "+Code",
    value: "+Code",
    languageCode: "+Code", // Used to show the globe icon
    isPlaceholder: true,
  };

  return (
    <div
      className="modalCus"
      id="myModal"
      onRequestClose={handleCloseFnLnModal}
      shouldCloseOnOverlayClick={true}>
      <div
        className="modal-dialog modal-dialog-centered custom-width-model"
        style={{ maxWidth: "440px", height: "250px" }}>
        <div className="modal-content" style={{ minHeight: "250px" }}>
          <div className="modal-header d-flex justify-content-right">
            <h4
              className="mb-0 text-danger fw-bold font-20 clsFnLnHeading"
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_EditReaderDetails}
            </h4>

            <button
              type="button"
              className="btn btn-outline-danger Readerclose modalclose download  mt-2"
              onClick={() => handleCloseFnLnModal()}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>
          <div className="modal-body ps-1 pt-0">
            <p className="wordwrap mail-text text-wrap">{currentEmail}</p>
            <div className="col-sm-12 col-md-12 res-pe0 ps-3 readerEdit-mail">
              <input
                className="clsFnLn w-100 form-control"
                name="FirstName"
                title={selectedLanguage.LstLanguageCodes.UI_FirstName}
                placeholder={selectedLanguage.LstLanguageCodes.UI_FirstName}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}></input>
            </div>
            <div className="col-sm-12 col-md-12 res-pe0 mt-3 ps-3 readerEdit-mail">
              <input
                className="clsFnLn w-100 form-control"
                name="LastName"
                title={selectedLanguage.LstLanguageCodes.UI_LastName}
                placeholder={selectedLanguage.LstLanguageCodes.UI_LastName}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}></input>
            </div>
            <div className="col-sm-12 col-md-12 res-pe0 mt-3 ps-3  readerEdit-mail">
              <Select
                className="sendVerficationCodeBorder"
                options={VerificationOptions}
                value={selectedVerificationOption}
                onChange={(event) => handleAuthTypeChange(event)}
                placeholder={
                  selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo
                }
                styles={{
                  control: (provided) => ({
                    ...provided,
                    display: "flex",
                    fontSize: "15px",
                    width: "100%",
                    minHeight: "40px",
                    height: "40px",
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    height: "40px",
                  }),
                  indicatorsContainer: (provided) => ({
                    ...provided,
                    height: "40px",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "center",
                    width: "100%",
                    cursor: "default",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    // width: "233px",
                    overflow: "hidden",
                    // marginTop: '18px',
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginTop: "3px",
                  }),
                  menuPortal: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    // width: "233px",
                    //marginTop: '4px',
                  }),
                }}
              />
            </div>
            {/* <div className="col-sm-12 col-md-12 res-pe0 mt-3 px-3 d-flex align-items-center readerEdit-mail">
              <div className="custom-inputBorder1">
                <SelectCountry
                  value={selectedCode?.value ? selectedCode : globePlaceholder}
                  onChange={(event) => handleCodeChange(event)}
                  options={countryCodeDrpOptions}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      fontSize: "15px",
                      height: "45px",
                      width: "163px",
                      border: "1px solid #ccc",
                      borderRadius: "4px 0 0 4px",
                      boxShadow: "1px 5px 5px -4px rgb(195 198 203)",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "280px",
                      marginTop: "20px",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  menuShouldScrollIntoView={false}
                  getOptionLabel={(e) => `${e.label}`}
                  getOptionValue={(e) => `${e.value}`}
                  formatOptionLabel={(data, { context }) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        className={`${data.label === "+Code"
                          ? "bg-  "
                          : `bg-${data.languageCode}`
                          }`}
                        style={{
                          width: "36px",
                          height: "16px",
                          marginRight: "8px",
                        }}></div>
                      {context === "menu"
                        ? `${data.label}`
                        : `${data.value.split("-")[0]}`}
                    </div>
                  )}
                  noOptionsMessage={() => null}
                />
              </div>
              <input
                type="text"
                className="form-control res-mobileinput"
                value={mobileNumber}
                maxLength={
                  selectedCode == undefined ||
                    selectedCode == null ||
                    selectedCode == "" ||
                    selectedCode == [] ||
                    selectedCode.value == "+Code"
                    ? 10
                    : selectedCode.mobileMaxLeng
                }
                onChange={(evnt) => handleMobileChange(evnt)}
                placeholder={selectedLanguage.LstLanguageCodes.UI_Mobile}
                style={{
                  height: "45px",
                  width: "56%",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                  borderRadius: "0 4px 4px 0",
                  padding: "14px",
                  position: "absolute",
                  left: "178px",
                }}
              />
            </div> */}
            <div className="col-sm-12 col-md-12 col-lg-12 mt-3 ps-3">
              <div class="input-group custom-inputBorder">
                <span
                  className="input-group-text mobile-group50"
                  style={{ padding: "0px", width: "30%" }}>
                  <SelectCountry
                    value={
                      selectedCode?.value ? selectedCode : globePlaceholder
                    }
                    onChange={(event) => handleCodeChange(event)}
                    options={countryCodeDrpOptions}
                    menuPosition="fixed"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        display: "flex",
                        fontSize: "15px",
                        width: "100%",
                        minHeight: "40px",
                        height: "40px",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "40px",
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        height: "40px",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "center",
                        width: "100%",
                        cursor: "default",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                        width: "233px",
                        overflow: "hidden",
                        // marginTop: '18px',
                        maxHeight: "300px",
                        overflowY: "auto",
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                        width: "233px",
                        //marginTop: '4px',
                      }),
                      indicatorSeparator: () => ({
                        display: "none",
                      }),
                    }}
                    menuPortalTarget={document.body}
                    getOptionLabel={(e) => `${e.label}`}
                    getOptionValue={(e) => `${e.value}`}
                    title="Select code"
                    formatOptionLabel={(data, { context }) => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <div
                          className={`${data.label === "+Code"
                            ? "bg-"
                            : `bg-${data.languageCode}`
                            }`}
                          style={{
                            width: "36px",
                            height: "16px",
                            marginRight: "8px",
                          }}></div>
                        {context === "menu"
                          ? `${data.label}`
                          : `${data.value.split("-")[0]}`}
                      </div>
                    )}
                    noOptionsMessage={() => null}
                  />
                </span>
                <input
                  type="text"
                  className="form-control res-mobileinput"
                  value={mobileNumber}
                  maxLength={
                    selectedCode == undefined ||
                      selectedCode == null ||
                      selectedCode == "" ||
                      selectedCode == [] ||
                      selectedCode.value == "+Code"
                      ? 10
                      : selectedCode.mobileMaxLeng
                  }
                  onChange={(evnt) => handleMobileChange(evnt)}
                  placeholder={selectedLanguage.LstLanguageCodes.UI_Mobile}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-12 res-pe0 mt-3 ps-3 readerEdit-mail">
              <input
                className="clsFnLn w-100 form-control"
                // disabled={securityLevl2}
                name="reference"
                title={selectedLanguage.LstLanguageCodes.UI_ReferenceTxt}
                placeholder={selectedLanguage.LstLanguageCodes.UI_ReferenceTxt}
                value={reference}
                onChange={(e) => setReference(e.target.value)}></input>
            </div>
            <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
              <div className={`checkbox mt-0 mb-0 d-flex align-items-center ${!docLevelCanPrint || (readerPrint && printEnabledType === "everyone") ? "disabled" : ""}`} style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap", position: "relative", left: "1rem" }}>
                <label className="ps-0 mb-0">
                  <input
                    type="checkbox"
                    checked={!docLevelCanPrint ? false : (readerPrint && printEnabledType === "everyone" ? true : readerPrint)}
                    disabled={!docLevelCanPrint || (readerPrint && printEnabledType === "everyone") || !readerPrint && printEnabledType !== "selectedUsers"}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      if (!checked) {
                        setPreviousMaxPrints(maxPrintsPerIndReader);
                        setMaxPrintsPerIndReader("");
                      } else {
                        setMaxPrintsPerIndReader(previousMaxPrints);
                      }
                      setReaderPrint(checked);
                    }}
                  />
                  <span className="cr" tabIndex="42" style={{ right: "5px" }}>
                    <i className="cr-icon material-icons">check</i>
                  </span>
                  <span className={`toolltipModified  top`}
                    style={{ right: "7px" }}>
                    {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                  </span>
                </label>
              </div>
              <div className="d-flex flex-grow-1 align-items-center">
                <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder" style={{ flex: 1, minWidth: "150px" }}>
                  <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                    {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                  </span>
                  <input type="text" className="control form-control h-47p border-Left"
                    placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                    value={maxPrintsPerIndReader}
                    onChange={(e) => {
                      const textValue = e.target.value.replace(/[^0-9]/g, "");
                      if (textValue === "" || (textValue.length <= 4 && parseInt(textValue, 10) >= 1 && parseInt(textValue, 10) <= 9999)) {
                        setMaxPrintsPerIndReader(textValue);
                      }
                    }}
                    disabled={!readerPrint}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 my-3">
              <button
                type="button"
                onClick={() => {
                  setPreviousMaxPrints("");
                  handleAddFnLn();
                }}
                className="btn btn-primary px-4"
                style={{ float: "inline-end" }}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditReaderModal;
